<template>
    <!-- BEGIN FOOTER -->
    <div class="footer-wrapper">
        <div class="footer-section f-section-1">
            <p class="">Copyright © {{ year }}. E-Tourism Kabupaten Jepara. All rights reserved.</p>
        </div>
        <div class="footer-section f-section-2">
            <p class="">
                Development by <a class="text-info" target="_blank" href="https://visualmedia.web.id">Visualmedia</a>
            </p>
        </div>
    </div>
    <!-- END FOOTER -->
</template>

<script setup>
import { ref } from 'vue';

const year = ref(new Date().getFullYear());
</script>
